
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs-landing",
      function () {
        return require("private-next-pages/jobs-landing.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs-landing"])
      });
    }
  